import { useEffect } from "react";
import styles from './useOverlay.scss';

export default function useOverlay(showOverlay) {
  useEffect(() => {
    if (showOverlay) {
      document.body.classList.add(styles.overlay);
    } else {
      document.body.classList.remove(styles.overlay);
    }
    return () => {
      document.body.classList.remove(styles.overlay);
    }
  }, [showOverlay]);
}